var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7171 13.5529C23.3287 14.1592 24 15.084 24 16.2361V17C24 18.6569 22.6569 20 21 20L3 20C1.34315 20 -7.24234e-08 18.6568 0 17L3.33916e-08 16.2361C8.37514e-08 15.084 0.671269 14.1592 1.28289 13.5529C1.67828 13.1609 2 12.6468 2 12C2 11.3532 1.67828 10.8391 1.28289 10.4471C0.671269 9.84081 3.53362e-07 8.91601 4.03722e-07 7.76392L4.37113e-07 7.00002C5.09536e-07 5.34317 1.34314 4.00002 3 4.00002L21 4C22.6569 4 24 5.34314 24 7V7.76392C24 8.91601 23.3287 9.84081 22.7171 10.4471C22.3217 10.8391 22 11.3532 22 12C22 12.6468 22.3217 13.1609 22.7171 13.5529ZM22 16.2361C22 15.8731 21.7734 15.4335 21.3091 14.9732C20.6958 14.3653 20 13.3707 20 12C20 10.6293 20.6958 9.63474 21.3091 9.02679C21.7734 8.56645 22 8.12693 22 7.76392V7C22 6.44771 21.5523 6 21 6L3 6.00002C2.44771 6.00002 2 6.44774 2 7.00002V7.76392C2 8.12692 2.22658 8.56644 2.69094 9.02679C3.3042 9.63474 4 10.6293 4 12C4 13.3707 3.3042 14.3653 2.69094 14.9732C2.22658 15.4336 2 15.8731 2 16.2361V17C2 17.5523 2.44772 18 3 18L21 18C21.5523 18 22 17.5523 22 17V16.2361Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7071 10.7071L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071C8.90237 14.3166 8.90237 13.6834 9.29289 13.2929L13.2929 9.29289C13.6834 8.90237 14.3166 8.90237 14.7071 9.29289C15.0976 9.68342 15.0976 10.3166 14.7071 10.7071Z",
    fill: "#777E91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10Z",
    fill: "#777E91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14C13 14.5523 13.4477 15 14 15C14.5523 15 15 14.5523 15 14C15 13.4477 14.5523 13 14 13C13.4477 13 13 13.4477 13 14Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.ed4608d9428bf5d8e868b0f5eb9874b5.svg";
export { ForwardRef as ReactComponent };